import React from 'react';
import { Card } from 'semantic-ui-react';
import { Container, Row, Col } from 'react-bootstrap';

const Pendidikan = () => (
    <>
        <Container>
            <Row sm={12} xs={12}>
                <Col className="mb-2" >
                    <h2>Formal Education</h2>
                    <Card.Group>
                        <Card
                            href='http://fis.unp.ac.id/index.php/en/' target='_blank'
                            header='Public Administration'
                            meta='DROP-OUT from Universitas Negeri Padang | 2011-2018'
                            description='i am a Front-End Developer living in Padang who enjoys climbing mountain and hanging with the books.'
                        />
                        <Card

                            header='Social Science'
                            meta='Pertiwi 1 Senior High School | 2009-2011'
                            description='I am active in scouting organization activities'
                        />
                    </Card.Group>
                </Col>

                <Col className="mb-2">
                    <h2>Informal Education</h2>
                    <Card.Group>
                        <Card
                            href='https://niomic.com' target='_blank'
                            header='Online Coding Bootcamp | Belajar Programming'
                            meta='PT. Niomic - Agust 2018 - Present'
                            description='Belajar pemograman HTML, CSS, Command Line, Git dan Github, Javascript, React JS, Database SQL dan NO SQL, Node JS, Deployment, React Native (Android), PHP, Golang selama 12 bulan.'
                        />
                        <Card
                            href='https://sekolahkoding.com' target='_blank'
                            header='Belajar Progrmming dan Web Development Online'
                            meta='SekolahKoding - Oct 2018 - Present'
                            description='Video tutorial web development dan programming dalam bahasa Indonesia.'
                        />
                        <Card

                            header='Geladian Daerah Pecinta Alam Sumatera Barat'
                            meta='SEKBER PA SUMBAR - 2016'
                            description='Pelatihan Kegiatan Alam Bebas dan pengenalan kearifan lokal yang diadakan bergiliran se Indonesia dalam 4 tahun sekali.'
                        />
                    </Card.Group>
                </Col>

                <Col className="mb-2">
                    <h2>Organization</h2>
                    <Card.Group>
                        <Card

                            header='Divisi Gunung-Rimba'
                            meta='Kel.Pecinta Alam Harimau Andalas | 2012 - Present'
                            description='Aktif dalam kegiatan kepedulian lingkungan hidup dan organisasi penggiat alam bebas'
                        />
                        <Card

                            header='Pramuka Peduli '
                            meta='Kwartir Daerah Sumbar | 2010-2011'
                            description='Tenaga relawan pasca bencana nasional Gempa bumi Sumatera Barat 30 September 2010 '
                        />
                        <Card

                            header='Satuan Karya Pramuka Dirgantara'
                            meta='Lanud Sutan Sjahrir Padang | 2010-2011'
                            description='Aktif dalam organisasi dan pelatihan kepramukaan Dirgantara '
                        />
                    </Card.Group>
                </Col>
            </Row>
        </Container>
    </>

)

export default Pendidikan